import styled from "styled-components";

// The base provenance line. Deliberately minimal: every surface wraps this in
// its own `styled(PriceNote)` to set the size and truncation its layout needs,
// so only the colour and the smallest type step are shared.
export const Note = styled.span`
  color: var(--color-text-muted);
  font-size: var(--text-xs);
`;
